<template>
  <el-table-column :prop="operatorName" :width="width">
    <template slot="header">
      <div >
        <span>{{title}}</span>
        <span class="itemEye" @click="handleSwitch" v-if="hasPermission(893)">
           <svg-icon
            :style="{ fontSize: calcFontSize(20, 20 * 0.3) }"
            icon-class="biyan"
            class="item-icon"
            :id="idName1"
          ></svg-icon>
          <svg-icon
            :style="{ fontSize: calcFontSize(20, 20 * 0.3) }"
            icon-class="zhengyan"
            class="item-icon"
            :id="idName2"
          ></svg-icon>
        </span>
      </div>
    </template>
    <template slot-scope="scope">
      <span v-if="operavalueShow">{{ scope.row[operatorName] | operatorNameFilter }}</span>
      <span v-else style="margin-left: 10px">{{ scope.row[operatorName] }}</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: "OperatorShow",
  props: {
    operatorName: {
      default() {
        return "operatorName";       
      },
    },
    title:{
      default() {
        return "所属运营商";       
      },
    },
    idName1:{
        default() {
          return "biyan";       
        },
    },
    idName2:{
        default() {
          return "zhengyan";       
        },
    },
    width:{
      type:Number,
      default:150
    }
  },
  data() {
    return {
      operavalueShow: true,
      operatorTitle:"所属运营商"
    };
  },
  methods: {
    handleSwitch() {
      this.operavalueShow = !this.operavalueShow;
      // console.log(this.idName1)
      // console.log(this.idName2)
      if(this.operavalueShow){
        $("#"+this.idName1).show();
        $("#"+this.idName2).hide();
      }else{
        $("#"+this.idName1).hide();
        $("#"+this.idName2).show()
      }
    },
    
  },
  mounted(){
    //  console.log(this.title)
  }
};
</script>

<style scoped>
.itemEye{
  cursor: pointer;
}
#zhengyan{
  display: none;
}
/* 调拨管理页面调入方 */
#id2{
   display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/OperatorShow/index.vue